import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = "AKM Laser - Machines laser professionnelles CO2, Fibre & Mixtes",
  description = "Spécialiste des machines de gravure et découpe laser pour artisans et industriels. Accompagnement, formation et support inclus. Découvrez nos machines CO2, Fibre et Mixtes.",
  keywords = "machine laser, gravure laser, découpe laser, laser CO2, laser fibre, machine gravure professionnelle, AKM Laser",
  ogImage = "https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=1200&h=630&fit=crop",
  url = "https://laser-pro-akm.preview.emergentagent.com",
  type = "website",
  structuredData = null
}) => {
  const fullTitle = title.includes("AKM Laser") ? title : `${title} | AKM Laser`;
  
  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={ogImage} />
      
      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={url} />
      <meta property="twitter:title" content={fullTitle} />
      <meta property="twitter:description" content={description} />
      <meta property="twitter:image" content={ogImage} />
      
      {/* Additional SEO */}
      <link rel="canonical" href={url} />
      
      {/* Structured Data (JSON-LD) */}
      {structuredData && (
        <script type="application/ld+json">
          {JSON.stringify(structuredData)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
